<template lang="pug">
  .login
    .page-header
      h2 Sign In

    p You are being redirected...
</template>

<script>
import axios from 'axios';

export default {
  name: 'login',
  created() {
    axios.get(this.global_authUri, {
      withCredentials: true,
    }).then((response) => {
      if (response.data.success === true) {
        this.global_verifySession(response.data.loginKey, response.data.ip, (session) => {
          if (session.success) {
            this.$store.commit('setUser', response.data);
            this.$router.push('/');
          }
        });
      } else {
        window.location = 'https://raid-gaming.net/login/';
      }
    }).catch((err) => {
      console.log(err);
    });
  },
};
</script>
